/**
 * Generated from SceneCreatorLayout.fla
 */
export function SceneCreatorLayout(this: ISceneCreatorLayout) {
	let main = this.main;
	SceneCreatorLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function SceneCreatorLayout_main(this: ISceneCreatorLayout_main) {
	let items = this.items;
	SceneCreatorLayout_items.call(this.items);
	items.x = -1024;
	items.y = 808.3;
	if (items.onLayout) items.onLayout();
	let hud = this.hud;
	SceneCreatorLayout_hud.call(this.hud);
	hud.x = -1024;
	hud.y = -768;
	if (hud.onLayout) hud.onLayout();
	return this;
}
function SceneCreatorLayout_items(this: ISceneCreatorLayout_items) {
	let carousel = this.carousel;
	SceneCreatorLayout_carousel.call(this.carousel);
	carousel.x = 1022.7;
	carousel.y = -164.15;
	if (carousel.onLayout) carousel.onLayout();
	return this;
}
function SceneCreatorLayout_carousel(this: ISceneCreatorLayout_carousel) {
	let buttonPrev = this.buttonPrev;
	SceneCreatorLayout_buttonPrev.call(this.buttonPrev);
	buttonPrev.x = -995;
	buttonPrev.y = -114.9;
	buttonPrev.width = 173.00;
	buttonPrev.height = 211.00;
	if (buttonPrev.onLayout) buttonPrev.onLayout();
	let buttonNext = this.buttonNext;
	SceneCreatorLayout_buttonNext.call(this.buttonNext);
	buttonNext.x = 822;
	buttonNext.y = -114.9;
	buttonNext.width = 173.00;
	buttonNext.height = 211.00;
	if (buttonNext.onLayout) buttonNext.onLayout();
	let itemsRect = this.itemsRect;
	SceneCreatorLayout_itemsRect.call(this.itemsRect);
	itemsRect.x = -704.15;
	itemsRect.y = -113.3;
	itemsRect.width = 1408.25;
	itemsRect.height = 209.05;
	if (itemsRect.onLayout) itemsRect.onLayout();
	let itemsMask = this.itemsMask;
	if (!itemsMask[0]) itemsMask[0] = itemsMask.elementFactory ? itemsMask.elementFactory(0) : {x:0, y:0};
	itemsMask[0].x = 821.997;
	itemsMask[0].y = -209.300;
	if (!itemsMask[1]) itemsMask[1] = itemsMask.elementFactory ? itemsMask.elementFactory(1) : {x:0, y:0};
	itemsMask[1].x = 821.997;
	itemsMask[1].y = 122.804;
	if (!itemsMask[2]) itemsMask[2] = itemsMask.elementFactory ? itemsMask.elementFactory(2) : {x:0, y:0};
	itemsMask[2].x = -822.000;
	itemsMask[2].y = 122.804;
	if (!itemsMask[3]) itemsMask[3] = itemsMask.elementFactory ? itemsMask.elementFactory(3) : {x:0, y:0};
	itemsMask[3].x = -822.000;
	itemsMask[3].y = -209.300;
	return this;
}
function SceneCreatorLayout_buttonPrev(this: ISceneCreatorLayout_buttonPrev) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-back.png", 0.000, 0.000);
	return this;
}
function SceneCreatorLayout_buttonNext(this: ISceneCreatorLayout_buttonNext) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-next.png", 0.000, 0.000);
	return this;
}
function SceneCreatorLayout_itemsRect(this: ISceneCreatorLayout_itemsRect) {
	return this;
}
function SceneCreatorLayout_itemsMask(this: ISceneCreatorLayout_itemsMask) {
	return this;
}
function SceneCreatorLayout_hud(this: ISceneCreatorLayout_hud) {
	let buttonHome = this.buttonHome;
	SceneCreatorLayout_buttonHome.call(this.buttonHome);
	buttonHome.x = 27.6;
	buttonHome.y = 16.9;
	buttonHome.width = 218.00;
	buttonHome.height = 166.00;
	if (buttonHome.onLayout) buttonHome.onLayout();
	let buttonRandom = this.buttonRandom;
	SceneCreatorLayout_buttonRandom.call(this.buttonRandom);
	buttonRandom.x = 290.65;
	buttonRandom.y = 16.9;
	buttonRandom.width = 218.00;
	buttonRandom.height = 166.00;
	if (buttonRandom.onLayout) buttonRandom.onLayout();
	return this;
}
function SceneCreatorLayout_buttonHome(this: ISceneCreatorLayout_buttonHome) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-home.png", 0.000, 0.000);
	return this;
}
function SceneCreatorLayout_buttonRandom(this: ISceneCreatorLayout_buttonRandom) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-refresh.png", 0.000, 0.000);
	return this;
}
interface ISceneCreatorLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ISceneCreatorLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ISceneCreatorLayoutSprite extends ISceneCreatorLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ISceneCreatorLayoutText extends ISceneCreatorLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ISceneCreatorLayoutPolygon extends ISceneCreatorLayoutArray<{x:number,y:number}> {
}
interface ISceneCreatorLayout {
	readonly main: ISceneCreatorLayout_main;
}
interface ISceneCreatorLayout_main extends ISceneCreatorLayoutContainer {
	readonly items: ISceneCreatorLayout_items;
	readonly hud: ISceneCreatorLayout_hud;
}
interface ISceneCreatorLayout_items extends ISceneCreatorLayoutContainer {
	readonly carousel: ISceneCreatorLayout_carousel;
}
interface ISceneCreatorLayout_carousel extends ISceneCreatorLayoutContainer {
	readonly buttonPrev: ISceneCreatorLayout_buttonPrev;
	readonly buttonNext: ISceneCreatorLayout_buttonNext;
	readonly itemsRect: ISceneCreatorLayout_itemsRect;
	readonly itemsMask: ISceneCreatorLayout_itemsMask;
}
interface ISceneCreatorLayout_buttonPrev extends ISceneCreatorLayoutSprite {
}
interface ISceneCreatorLayout_buttonNext extends ISceneCreatorLayoutSprite {
}
interface ISceneCreatorLayout_itemsRect extends ISceneCreatorLayoutContainer {
}
interface ISceneCreatorLayout_itemsMask extends ISceneCreatorLayoutPolygon {
}
interface ISceneCreatorLayout_hud extends ISceneCreatorLayoutContainer {
	readonly buttonHome: ISceneCreatorLayout_buttonHome;
	readonly buttonRandom: ISceneCreatorLayout_buttonRandom;
}
interface ISceneCreatorLayout_buttonHome extends ISceneCreatorLayoutSprite {
}
interface ISceneCreatorLayout_buttonRandom extends ISceneCreatorLayoutSprite {
}
